export default {
  title: "Register",
  toLoginMessage: "Log in",
  subscribe: "Subscribe to EXPOСENTRE notifications",
  consent1:
    "I hereby consent to the processing of my personal data on the following",
  consent2: "conditions for the processing of personal data",
  submit: "Submit",
  successMessage:
    "If an account with the specified email address exists and the email address is verified, we will send a password reset link.",

  error: {
    userExists: "User with such e-mail already exists.",
    validation: "Validation error.",
    userCreation: "User creation error.",
    userElementCreation: "User element creation error.",
    server: "Server error"
  }
};
